import { IonIcon } from '@ionic/react';
import React from 'react';

import './Metric.css';

interface MetricProps {
  icon: string;
  label: string;
  value: React.ReactNode;
  barType: string;
  inView: boolean;
  direction?: 'left' | 'right';
}

const Metric: React.FC<MetricProps> = ({
  icon,
  label,
  value,
  barType,
  inView,
  direction = 'left'
}) => (
  <div
    className={`metric${inView ? ' metric--in-view' : ''} metric--${direction}`}
  >
    <div className="metric__bar" data-metric-bar={barType}>
      <IonIcon icon={icon} className="metric__icon" />
      <p className="metric__label">{label}</p>
    </div>
    <p className="metric__value">{value}</p>
  </div>
);

export default Metric;
